
import React, { useState, useEffect, useRef } from 'react';
import { Box, Card, Divider, TableBody, Typography, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Avatar from "../../../../icons/Avatar.svg";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';
import EmailPage from './EmailPage';
import Paginator from "../../../../toolkit/Paginator";

import axios from '../../../../utils/fvAxios';
import { Autocomplete, } from '@mui/material';

import Status from "../../../../stories/StatusComponent/StatusComponent";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Nodata from "../../../Nodata/Nodata";
import { getOrgType } from '../../../../utils/Token';
import { ToastContainer, toast } from 'react-toastify';



function EnhancedTableHead(props) {
    const { onSelectAllClick, numSelected, rowCount, COUNT } = props;

    return (
        <TableRow sx={{ backgroundColor: "#e1e1e1" }} hidden={!COUNT}>
            <TableCell padding="checkbox">
                <Checkbox
                    color="primary"
                    indeterminate={numSelected > 0 && numSelected < rowCount}
                    checked={rowCount > 0 && numSelected === rowCount}
                    onChange={onSelectAllClick}
                    inputProps={{
                        "aria-label": "select all desserts"
                    }}
                />
            </TableCell>

            <TableCell sx={{ fontWeight: "bold" }}>Vendor Name</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
        </TableRow>

    );
}



function EnhancedTableToolbar(props) {
    const { numSelected, ChangeStatus, StatusIdsList, DialogOpenClick, setSelected, ClientList, ChangClient, ClientId, StatusList, StatusListId, VENDORS, ChangVendor, Companies, CompaniesList } = props;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const Clear = () => {
        setSelected([]);
    }
    const menuListRef = useRef(null);
    const handleMenuOpen = () => {
        scrollToTopOfOtions();
    };
    const scrollToTopOfOtions = () => {
        setTimeout(() => {
            if (menuListRef.current) {
                const children = menuListRef.current.children;
                if (children.length >= 2) {
                    const secondLastOption = children[children.length - 2];
                    if (secondLastOption) {
                        secondLastOption.scrollTop = 0;
                    }
                }
            }
        }, 5);
    };
    return (<>
        <Card style={{ padding: "10px" }}>
            <Stack direction={"row"} spacing={3}>
                <div style={{ marginTop: "10px" }}>
                    <span style={{ fontSize: "20px", fontWeight: "bold" }}> Vendors list</span>
                </div>
                <div hidden={numSelected == ""}>
                    <Stack direction={"row"} spacing={3}>
                        <div style={{ marginTop: "15px" }}>
                            {/* <Typography

                                color="inherit"
                                variant="subtitle1"
                            >
                                {numSelected} Vendors Selected
                            </Typography> */}
                            <span >  {numSelected} Vendors Selected</span>
                        </div>
                        <div>
                            <Button variant="contained" sx={{ padding: "20px" }} onClick={DialogOpenClick}>EMAIL</Button>
                        </div>
                        <div style={{ float: "right" }}>
                            <Button variant="outlined" color="error" sx={{ padding: "20px", width: "120px" }} onClick={Clear}>X Cancel</Button>
                        </div>
                    </Stack>
                </div>
            </Stack>
            {/* ) : ( */}
            <Divider sx={{ backgroundColor: "#667085", height: "2px", marginTop: "17px" }} />
            <div style={{ marginLeft: "15px", marginBottom: "15px", marginTop: "10px" }} >      {/* hidden={numSelected > 0} */}
                <Stack spacing={2} direction="row">
                    <div style={{ marginRight: "10px" }}>
                        <span className="mx-2">
                            Clients<span className="red-color">*</span>
                        </span>
                        <br />
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            labelId="demo-multiple-name-label"
                            id="demo-multiple-name"
                            size="small"
                            value={ClientId}
                            onChange={(e) => {
                                Clear();
                                ChangClient(e.target.value)
                            }}
                            MenuProps={MenuProps}
                        >
                            {ClientList?.map((r, i) =>
                                <MenuItem key={i} value={r?.value} >{r?.text}</MenuItem>
                            )}
                        </Select>
                    </div>
                    <div hidden={ClientId == ""}>
                        <span className="mx-2">
                            Vendors<span className="red-color">*</span>
                        </span>
                        <br />

                        <Autocomplete
                            getOptionLabel={(comp) => `${comp?.value}`}
                            value={VENDORS}
                            options={Companies}
                            size="small"
                            placeholder='fghjkhg'
                            onChange={(event, value) => ChangVendor(value)}
                            renderInput={(params) => (
                                <TextField {...params} sx={{ width: "300px" }} variant="outlined" fullWidth onChange={(e) => CompaniesList(e?.target?.value)} />
                            )}
                        />
                    </div>
                    <div style={{ marginLeft: "Auto" }} hidden={ClientId == ""}>
                        <span className="mx-2">
                            Status<span className="red-color">*</span>
                        </span>
                        <br />
                        {/* <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "320px"
                            }}
                            labelId="demo-multiple-name-label"
                            value={StatusListId || ""}
                            id="demo-multiple-name"
                            size="small"
                            onChange={(e) => ChangeStatus(e.target.value)}
                            MenuProps={MenuProps}
                        >
                            {StatusList?.map((r, i) =>
                                <MenuItem key={i} value={r?.key} sx={{ display: r?.value == "" ? "none" : "block" }}>{r?.value}</MenuItem>
                            )}
                        </Select> */}

                        <Select
                            labelId="docs-label"
                            id="docs-select"
                            multiple
                            size='small'
                            sx={{ width: "320px", overflow: "hidden" }}
                            name="Site Safety Representive"
                            value={StatusListId || []}
                            MenuProps={{
                                ref: menuListRef,
                                PaperProps: MenuProps.PaperProps,
                            }
                            }
                            renderValue={(selected) =>
                                selected
                                    .map((key) => StatusList?.find((doc) => doc?.key === key)?.value)
                                    .filter((text) => text !== undefined)
                                    .join(", ")
                            }
                            onChange={(e) => ChangeStatus(e.target.value)}
                            inputProps={{ 'aria-label': 'Select Documents' }}
                        >
                            <MenuItem key="Select All">
                                <Checkbox
                                    id="select-all-checkbox"
                                    indeterminate={
                                        StatusListId?.length > 0 && StatusListId?.length < StatusList?.length
                                    }
                                    checked={StatusListId?.length === StatusList?.length}
                                    onChange={(event) => {
                                        if (event?.target?.checked) {
                                            ChangeStatus(StatusList?.map((doc) => doc?.key));
                                            scrollToTopOfOtions();

                                        } else {
                                            ChangeStatus("");
                                        }
                                    }}
                                />
                                <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                    Select All
                                </label>
                                {/* <ListItemText primary="Select All" /> */}
                            </MenuItem>
                            {StatusList?.map((r) => (
                                <MenuItem key={r?.key} value={r?.key} hidden={r?.key == -1} >
                                    <Checkbox checked={StatusListId?.indexOf(r?.key) > -1} />
                                    <ListItemText primary={r?.value} />
                                </MenuItem>
                            ))}
                        </Select>

                        {/* <Select
                            labelId="docs-label"
                            id="docs-select"
                            multiple
                            size='small'
                            sx={{ width: "340px", overflow: "hidden" }}
                            name="clientIds"
                            value={StatusListId || []}
                            onChange={(e) => ChangeStatus(e.target.value)}
                            MenuProps={{
                                ref: menuListRef,
                                PaperProps: MenuProps.PaperProps,
                            }
                            }
                            renderValue={(selected) =>
                                selected
                                    .map((key) => StatusList?.find((doc) => doc?.key === key)?.value)
                                    .filter((value) => value !== undefined)
                                    .join(", ")
                            }
                            inputProps={{ 'aria-label': 'Select Documents' }}
                        >
                            <MenuItem key="Select All">

                                <Checkbox
                                    id="select-all-checkbox"
                                    indeterminate={
                                        StatusListId?.length > 0 && StatusListId?.length < StatusList?.length
                                    }
                                    checked={StatusListId?.length === StatusList?.length}
                                    onChange={(event) => {
                                        if (event?.target?.checked) {
                                            ChangeStatus(StatusList?.map((doc) => doc?.key));
                                            scrollToTopOfOtions();

                                        } else {
                                            ChangeStatus([]);
                                        }
                                    }}
                                />
                                <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                    Select All
                                </label>
                            </MenuItem>
                            {StatusList?.map((r) => (
                                <MenuItem key={r?.key} value={r?.key} hidden={r?.key == -1} >
                                    <Checkbox checked={StatusListId?.indexOf(r?.key) > -1} />
                                    <ListItemText primary={r?.value} />

                                </MenuItem>
                            ))}
                        </Select> */}


                    </div>

                </Stack >
            </div>
            {/* )} */}
        </Card >

    </>);
}


export default function EmailVendor() {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [selected, setSelected] = React.useState([]);
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = VendorsList.map((n) => n);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, r) => {
        const selectedIndex = selected.indexOf(r);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, r);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        setSelected(newSelected);
    };

    const isSelected = (prequalificationId) => selected.indexOf(prequalificationId) !== -1;


    const [dialogopen, setDialogOpen] = React.useState(false);
    const DialogOpenClick = () => {
        setDialogOpen(true);
    };
    const DialogCloseClick = () => {
        setDialogOpen(false);
    };
    useEffect(() => {
        Details();
        Cliens();
    }, []);


    const [spinner, setSpinner] = React.useState(false);
    const [statusList, setStatusList] = React.useState([]);
    const [clientList, setClientList] = React.useState([]);
    const [statusListId, setStatusListId] = React.useState([]);
    const [clientId, setClientId] = React.useState("");


    const [Companies, setCompanies] = React.useState([]);
    const [Vendors, setVendors] = React.useState(null);
    const [VendorsList, setVendorsList] = React.useState([]);
    const [VendorId, setVendorId] = React.useState("");
    const [Count, setCount] = useState("");
    const [number, setNumber] = useState("1");

    useEffect(() => {
        ChangeStatus(statusListId);
    }, [number]);

    async function Details() {
        const res = await axios.get("Prequalification/GetPQStatusList");
        setStatusList(res?.data?.data.filter((r) => r.key != -1));
    }
    async function Cliens() {
        const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false");
        setClientList(res?.data?.data);
        if (getOrgType() == "Client") {
            ChangeClient(res?.data?.data[0]?.value);
        }
    }
    const ChangeVendor = async (event) => {
        setStatusListId([]);
        setVendorId(event?.key);
        setVendors(event);
        setSpinner(!spinner);
        const res = await axios.post("Vendor/VendorSearchResultsForEmailing?searchType=Name&clientId=" + clientId + "&vendorId=" + event?.key + "&sortBy=0&pageNumber=" + number + "&pageSize=" + 50);
        setVendorsList(res?.data?.data);
        setCount(res?.data?.count);
        setSpinner(spinner);
    }
    const ChangeStatus = async (e) => {
        setVendors(null);
        setStatusListId(e);
        if (e != "") {
            setSpinner(!spinner);
            const res = await axios.post("Vendor/VendorSearchResultsForEmailing?searchType=Status&clientId=" + clientId + "&prequalStatus=" + e + "&sortBy=1&pageNumber=" + number + "&pageSize=" + 50);
            setVendorsList(res?.data?.data);
            setCount(res?.data?.count);
            setSpinner(spinner);
        } else {
            setCount("");
        }
    }
    const ChangeClient = (e) => {
        setClientId(e);
        setVendors(null);
        setStatusListId([]);
        setVendorsList([]);
        setCount("");
        setNumber("1");
    }

    const GetCompanies = async (val) => {
        const response = await axios.get("Vendor/GetVendorsByClient?clientId=" + clientId + "&freeText=" + val);
        setCompanies(response?.data?.data);
    }
    const SpinnerClose = () => {
        setSpinner(false);
    };
    const Clear = () => {
        setSelected([]);
    }
    const handlePageChange = (event) => {
        setNumber(event);
        Clear();
    };
    return (
        <Box sx={{ width: "100%" }}>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <div>
                <Dialog
                    fullScreen={fullScreen}
                    open={dialogopen}
                    onClose={DialogCloseClick}
                >
                    <EmailPage DialogClose={DialogCloseClick} DialogOpen={DialogOpenClick} Selected={selected} ClientId={clientId} Clear={Clear} />
                </Dialog>
            </div>

            <Paper sx={{ width: "100%", mb: 2 }}>
                <EnhancedTableToolbar
                    numSelected={selected.length}
                    ClientList={clientList}
                    ChangClient={ChangeClient}
                    ClientId={clientId}
                    StatusList={statusList}
                    StatusListId={statusListId}
                    ChangeStatus={ChangeStatus}
                    Companies={Companies}
                    VENDORS={Vendors}
                    // StatusIdsList={statusListId}
                    ChangVendor={ChangeVendor}
                    CompaniesList={GetCompanies}
                    setSelected={setSelected}
                    DialogOpenClick={DialogOpenClick}
                />
                {clientId == ""
                    ?
                    <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, marginRight: "12px", width: "auto" }} className="text-center">
                        <span style={{ color: "#667085" }}>Please Select Client</span>
                    </Box>
                    : VendorId != "" || statusListId != ""
                        ? VendorsList?.length < 1 ? <div hidden={spinner}> <Nodata /> </div>
                            : <>
                                <TableContainer>
                                    <Table
                                        sx={{ minWidth: 750 }}
                                        aria-labelledby="tableTitle"
                                    >
                                        <EnhancedTableHead
                                            numSelected={selected.length}
                                            onSelectAllClick={handleSelectAllClick}
                                            rowCount={VendorsList?.length}
                                            COUNT={Count}
                                        />

                                        <TableBody>
                                            {VendorsList?.map((r, index) => {
                                                const isItemSelected = isSelected(r);
                                                return (
                                                    <TableRow
                                                        hover
                                                        onClick={(event) => handleClick(event, r)}
                                                        role="checkbox"
                                                        tabIndex={-1}
                                                        key={index}
                                                        selected={isItemSelected}
                                                        sx={{ cursor: "pointer" }}
                                                    >
                                                        <TableCell padding="checkbox">
                                                            <Checkbox
                                                                color="primary"
                                                                checked={isItemSelected}

                                                            />
                                                        </TableCell>
                                                        <TableCell >
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    "& svg": { m: 1.5 },
                                                                    "& hr": { mx: 0.5 },
                                                                }}
                                                            >
                                                                <img
                                                                    style={{ marginRight: "10px" }}
                                                                    src={Avatar}
                                                                    alt="avataricon"
                                                                />
                                                                <div>
                                                                    <span style={{ fontSize: "16px", color: "#101828" }}>
                                                                        {r?.name}
                                                                    </span><br />
                                                                    {r?.templateCode}
                                                                </div>
                                                            </Box>


                                                        </TableCell>

                                                        <TableCell sx={{ width: "5%" }}>
                                                            <Status type={r?.prequalificationStatusId} />
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </> : < Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, marginRight: "12px", width: "auto" }} className="text-center">
                            <span style={{ color: "#667085" }}>Please Select Vendor (or) Prequalification Status</span></Box>

                }
            </Paper >
            <div hidden={!Count}>
                <Paginator
                    count={Math.ceil(Count / 50)}
                    page={Number(number)}
                    margin="18px 0px"
                    onChange={handlePageChange}
                />
            </div>
        </Box >
    );
}





